import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { CommissionPhaseSchema } from "./CommissionPhase";
import { CompanySchema } from "./Company";
import { UserSchema } from "./User";

export const CommissionFieldsSchema = z.object({
  id: z.number().int(),
  /** @deprecated use `id` instead */
  //commissionId: z.number(),
  commissionNumber: z.string(),
  createdAt: z.string(),
  modificationDate: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  commissionAddress: z.string(),
  name: z.string(),
  creatorAccountUser: AccountUserSchema,
  creatorUser: UserSchema,
  company: CompanySchema,
  accountUser: AccountUserSchema,
  commissionPhase: CommissionPhaseSchema,
  documentSeriesDefinition: z.any(), // TODO: define schema
  user: UserSchema,
  commissionsUserUsers: z.array(UserSchema),
  place: z.any(),
  positions: z.any(),
});
export const PartialCommissionFieldsSchema =
  CommissionFieldsSchema.deepPartial();

export const CommissionExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
  attributes: z.array(z.any()), // TODO: define schema
  relations: z.object({
    documentInvoices: z.array(z.any()),
    documentStores: z.array(z.any()),
    documentOrders: z.array(z.any()),
    tasks: z.array(z.any()),
    documentOfferQuestions: z.array(z.any()),
    campaignOpportunities: z.array(z.any()),
    internalDocumentOrders: z.array(z.any()),
    emailMessages: z.array(z.any()),
    communicationThreads: z.array(z.any()),
    messageThreads: z.array(z.any()),
    odbcReports: z.array(z.any()),
    commissions: z.array(z.any()),
    products: z.array(z.any()),
    servicedProducts: z.array(z.any()),
  }),
  nextPhases: z.object({}),
  fullName: z.string(),
  procedureButtons: z.object({}),
});
export const PartialCommissionExtraFieldsSchema =
  CommissionExtraFieldsSchema.deepPartial();

export const CommissionSchema = z.intersection(
  CommissionFieldsSchema,
  CommissionExtraFieldsSchema
);

export type CommissionFields = z.infer<typeof CommissionFieldsSchema>;
export type PartialCommissionFields = z.infer<
  typeof PartialCommissionFieldsSchema
>;
export type CommissionExtraFields = z.infer<typeof CommissionExtraFieldsSchema>;
export type PartialCommissionExtraFields = z.infer<
  typeof PartialCommissionExtraFieldsSchema
>;
export type Commission = z.infer<typeof CommissionSchema>;
